import { render, staticRenderFns } from "./bdd-block.vue?vue&type=template&id=f09c697a"
import script from "./bdd-block.vue?vue&type=script&lang=js"
export * from "./bdd-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports